import React, { useMemo } from 'react';

import { FilterTypes } from '@candu-ai/analytics/search';
import { QueryId, QueryParamUrlObject } from '@candu-ai/analytics/types';
import { CollapsableTable } from '@candu-ai/analytics/ui';
import { ACTION_COLUMN } from 'canoe/components/Table/types';
import { getLocalisedNumber } from 'commons/utils';

import { TableFilterActions } from './TableFilterActions';

const getColumns = (title: string) => [
  {
    key: 'pathname',
    title: 'Path',
    isSortable: true,
    colSpan: 6,
  },
  {
    key: 'count',
    title,
    isSortable: true,
    render: (value: number) => getLocalisedNumber(value, 'en-US'),
  },
  {
    key: 'total',
    title: 'Percentage',
    isSortable: true,
    render: (text: string, record: any) => `${((record.count * 100.0) / record.total).toFixed(1)}%`,
  },
  {
    key: ACTION_COLUMN,
    title: 'actions',
    render: (text: string, record: any) => (
      <TableFilterActions filterType={FilterTypes.Pathname} value={record.pathname} />
    ),
  },
];

interface ByPathnameProps {
  queryId: QueryId;
  queryParams: QueryParamUrlObject;
  title: string;
}

const ByPathnameTable = ({ queryId, queryParams, title }: ByPathnameProps) => {
  const columns = useMemo(() => getColumns(title), [title]);
  return (
    <CollapsableTable
      label={`${title} by URL Path`}
      queryId={queryId}
      queryParams={queryParams}
      columns={columns}
    />
  );
};

interface Props {
  queryParams: QueryParamUrlObject;
}

export const ViewsByPathnameTable = ({ queryParams }: Props) => {
  return (
    <ByPathnameTable
      title="Views"
      queryId={QueryId.ViewsByPathnameTable}
      queryParams={queryParams}
    />
  );
};

export const InteractionsByPathnameTable = ({ queryParams }: Props) => {
  return (
    <ByPathnameTable
      title="Interactions"
      queryId={QueryId.InteractionsByPathnameTable}
      queryParams={queryParams}
    />
  );
};
